import { z } from "zod"

import { ProductSheetLanguages } from "@tfg/types/constants/language.constants"

export enum LanguageIso6391 {
  FR = "FR",
  EN = "EN",
  ZH = "ZH",
  PT = "PT",
  IT = "IT",
  ES = "ES",
  TR = "TR",
  NL = "NL",
  DE = "DE",
  AR = "AR",
  KO = "KO",
  JA = "JA",
  BE = "BE",
  RO = "RO",
  LT = "LT",
}

export const LanguageIso6391Schema = z.nativeEnum(LanguageIso6391)

export const ProductSheetLanguageSchema = z.nativeEnum(ProductSheetLanguages)
export type ProductSheetLanguage = z.infer<typeof ProductSheetLanguageSchema>
